<template>


  <div class="children-container">
    <div class="children-module-name"><span>商品订单</span></div>
    <div class="children-module-content" style="background-color: transparent;padding: 0!important;padding: 0 !important;">
      <div style="background-color: #fff;padding: 25px 25px 10px 25px;margin-bottom: 20px;">
        <a-form-model layout="inline">
          <a-form-model-item>
            <a-input placeholder="请输入订单号" v-model="page.order_id" size="small"></a-input>
          </a-form-model-item>
          <a-form-model-item label="下单时间" >
            <a-range-picker @change="changeTime"  style="width: 200px"/>
          </a-form-model-item>
        </a-form-model>
        <div style="display: flex;justify-content: center;align-items: center;margin-top: 10px;">
          <a-form-model-item>
            <a-button class="cu-btn" type="primary" @click="search">搜索</a-button>
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="resetForm" class="cu-btn" style="margin: 0 15px;border: 1px solid #008276;color: #008276;">重置</a-button>
          </a-form-model-item>
          <a-form-model-item>
            <!-- <a-button class="cu-btn" style="background-color: #e6f2f2;color: #008276;border: 1px solid #e6f2f2;">导出订单</a-button> -->
          </a-form-model-item>
        </div>
      </div>

      <div v-if="list.length == 0 && flag == true" style="display: flex;justify-content: center;align-items: center;flex-direction: column;padding: 40px 0;background: #fff">
        <img src="https://jc-yk-static.oss-cn-shanghai.aliyuncs.com/icons/nodata.png" alt="" style="width: 200px">
        <span style="margin-top: 10px;color: #666666;padding-right: 20px">暂无数据</span>
      </div>
      <div v-else>
        <div v-for="(item, index) in list" :key="index" class="product-list" style="background-color: #fff;padding: 20px 25px;font-size: 12px;margin-bottom: 20px;border-radius: 4px;">
          <div v-for="(good, index) in item.good_list" :key="index" style="padding-top: 10px;position: relative;">
            <div style="display: flex;align-items: center;">
              <div><span>{{good.strain_number}}</span></div>
              <div style="margin: 0 20px;"><span>{{good.common_name}}</span></div>
              <div><span v-html="good.strain_name"></span></div>
            </div>
            <div style="border-bottom: 1px solid #eee;">
              <div style="display: flex;align-items: center;padding: 10px 0;">
                <div style="margin-right: 20px;"><span style="font-weight: 600;">基因型: </span><span style="color: #008276;">{{good.gene}}</span></div>
                <div style="margin-right: 20px;"><span style="font-weight: 600;">周龄: </span><span style="color: #008276;">{{good.wks}}</span></div>
                <div style="margin-right: 20px;"><span style="font-weight: 600;">性别: </span><span style="color: #008276;">{{good.sex}}</span></div>
                <div style="margin-right: 20px;"><span style="font-weight: 600;">数量: </span><span style="color: #008276;">{{good.num}}</span></div>
                <div style="margin-right: 20px;"><span style="font-weight: 600;">小计: </span><span style="color: #008276;">{{good.price | fmtPrice3}}</span></div>
              </div>
              <div style="display: flex;padding: 0px 0 10px 0;">
                <div style="margin-right: 10px;"><span>运输方式: </span><span style="color: #008276;">{{item.transport_name}}</span></div>
                <div style="margin-right: 10px;"><span>包装方式: </span><span style="color: #008276;">{{item.pack_name}}</span></div>
                <div style="margin-right: 10px;"><span>包装信息: </span><span style="color: #008276;">{{good.ruleInfo}}</span></div>
                <div style="margin-right: 10px;"><span>到货时间: </span><span style="color: #008276;">{{good.delivery_time}}</span></div>
              </div>
            </div>
            <div style="border-bottom: 1px solid #eee;" v-if="item.files !=null" :ref="item.id" :id="item.id">
              <div>
                <div style="font-weight: bold;padding-top: 5px;margin-bottom: 5px">
                  相关文件列表
                </div>
                <div class="file-list" v-for="f in item.files" >
                  <a :href="f.name" download="">{{ f.name }}</a>
                </div>
              </div>
              <div class="bb" style="margin-top: 10px;padding-bottom: 5px">
                <span style="font-weight: bold">状态: </span>
                <span v-if="item.file_state == 'TRUE'">客户已确认</span>
                <span v-if="item.file_state == 'FALSE'">客户未确认</span>
                <a-button  v-if="item.file_state == 'FALSE'" @click="fileConfirmation(item)" type="primary" size="small" style="margin-left: 10px;height: 26px"><a-icon type="check-circle" /> 确认并查阅相关文件</a-button>
              </div>
            </div>

          </div>
          <div>
            <div style="padding: 10px 0 0 0 ;"><span style="font-weight: 600;">下单时间: </span><span>{{item.create_time}}</span></div>
          </div>
          <div>
            <div style="padding: 10px 0 0 0 ;"><span style="font-weight: 600;">收货地址: </span><span>{{item.address_json.province_name}}{{item.address_json.city_name}}{{item.address_json.area_name}}{{item.address_json.info}}({{item.name}} {{item.mobile}})</span></div>
          </div>
          <div>
            <div style="padding: 10px 0 0 0 ;"><span style="font-weight: 600;">开票信息: </span><span>开票类型：普通发票</span><span style="margin: 0 20px">单位名称：{{item.bill.name}}</span><span>纳税人识别号：{{item.bill.tax_number}}</span></div>
          </div>
          <div>
            <div style="padding: 10px 0 0 0 ;"><span style="font-weight: 600;">下单帐户: </span>
              <span>{{item.account.name}}</span>
              <span style="margin: 0 10px;">PI姓名: {{item.account.pi_name}}</span>
            </div>
          </div>
          <div style="display: flex;">
            <div style="padding: 10px 0 0 0 ;">
              <span style="font-weight: 600;">运费: </span>
              <span>{{item.freight}}</span>
            </div>
            <div style="padding: 10px 0 0 0 ;margin: 0 10px;">
              <span style="font-weight: 600;">包装费: </span>
              <span>{{item.packaging_fee}}</span>
            </div>
            <div style="padding: 10px 0 0 0 ;">
              <span style="font-weight: 600;">总金额: </span>
              <span>{{item.total_price}}</span>
            </div>
          </div>
          <div style="display: flex;justify-content: flex-end">
            <a-button @click="againOrder(item)" type="primary" size="small" style="margin-right: 10px"><a-icon type="copy" /> 再来一单</a-button>
<!--            <a-button @click="alipayThenPay(item.id)" type="primary" v-if="item.pay_state == 'FALSE' && item.state == 'TOBEPAID' && item.pay_type == 'ALIPAY'" size="small" style="margin-right: 10px"><a-icon type="alipay" /> 去付款</a-button>-->
<!--            <a-button @click="wxThenPay(item.id)" type="primary" v-if="item.pay_state == 'FALSE' && item.state == 'TOBEPAID' && item.pay_type == 'WECHAT'" size="small" style="margin-right: 10px"><a-icon type="wechat" /> 去付款</a-button>-->
<!--            <a-button @click="openCancel(item.id)" type="danger" v-if="item.pay_state == 'FALSE' && item.state == 'TOBEPAID'" size="small"><a-icon type="close-circle" /> 取消订单</a-button>-->
          </div>
        </div>

      </div>
      <div class="page-container">
        <a-pagination :hideOnSinglePage="true" :page-size.sync="page.pageSize" :total="page.totalRow" v-model="page.start"
                      @change="changePage" />
      </div>
<!--      <a-modal dialogClass="custom-dialog" :width="250" :maskClosable="false" v-model="wxQrVisible" title="微信支付二维码"-->
<!--               @cancel="wxPay('cancel')"-->
<!--               @ok="wxPay('ok')" :destroyOnClose="true" :disabled="$store.state.requestLoading" okText="我已完成支付">-->
<!--        <div id="qrcode"></div>-->
<!--      </a-modal>-->
    </div>
  </div>
</template>

<script>
import * as Api from './api';
import * as commonApi from '@/commonApi';
import {GetOrderSku, WxThenPay} from "./api";
import QRCode from "qrcodejs2";

export default {
  data() {

    return {
      wxQrUrl: '',
      wxQrVisible: false,
      list: [],
      page: {
        start: 1,
        limit: 10,
        pageSize: 0,
        totalRow: 0,
        order_id: '',
        start_time: '',
        end_time: '',
        state: undefined,
        pay_state: undefined
      },
      flag: false,
      filesColumns: [{
        title: "文件列表",
        dataIndex: "name",
        key: "name",
        slots: {
          customRender: 'name'
        },
      }]
    };
  },
  mounted() {
    this.getList();
  },
  methods: {


    // 搜索
    search() {
      this.getList();
    },

    // 重置
    resetForm() {
      this.page.order_id = '';
      this.page.state = undefined;
      this.page.start_time = '';
      this.page.end_time = '';
    },

    // 时间
    changeTime(e, s) {
      this.start_time = s[0];
      this.end_time = s[1];
    },

    // 获取列表
    async getList() {
      let res = await Api.GetList(this.page);
      if (res && res["code"] == "0") {
        this.page.totalRow = res.page.totalRow;
        this.page.pageSize = res.page.pageSize;
        res.page.list.forEach((item, index)=>{
          item['good_list'] = JSON.parse(item['good_list']);
          item['address_json'] = JSON.parse(item['address_json']);
        })

        res.page.list.forEach(item=>{
          let good_list = item['good_list'];
          good_list.forEach(g=>{
            let packbox_id = g['packbox_id'];
            let transport_id = g['transport_id'];

            g.transportModeList.forEach(t=>{
              if (t.id == transport_id) {
                item['transport_name'] = t.name;
              }
            })

            g.packageList.forEach(p=>{
              if (p.id == packbox_id) {
                item['pack_name'] = p.value;
              }
            })

          })
          item['good_list'] = good_list;

          if (item.files != null) {
            try {
              let temp = JSON.parse(item.files);
              let tempArr = [];
              temp.forEach(item=>{
                tempArr.push({name: item})
              })
              item.files = tempArr;
            } catch (e) {

            }
          }

        })
        this.list = res.page.list;
        this.flag = true;
      }
    },
    // 改变分页
    changePage(e) {
      this.page.start = e;
      this.getList();
    },
    // 再来一单的sku
    async getOrderSku(list, id) {
      let res = await Api.GetOrderSku({id: id, type:'delete'});
      if (res && res["code"] == "0") {
        res.store.forEach((item,index)=> {
          list[index]['age_json'] = JSON.parse(item.target['age_json']);
          list[index]['gene_json'] = JSON.parse(item.target['gene_json']);
          list[index]['sex_json'] = JSON.parse(item.target['sex_json']);
          list[index]['state_json'] = JSON.parse(item.target['state_json']);
          list[index]['priceList'] = item.priceList;
          list[index]['add_time'] =  new Date();
        })

        let cartList = window.localStorage.getItem('cartList');
        let token = window.localStorage.getItem('token');
        let userid = window.localStorage.getItem('userid');


        // 根据 token 获取购物车信息
        if (token && cartList) {
          let tempCartList = JSON.parse(cartList);
          let temp = [];
          tempCartList.forEach(item => {
            if (item.userid == userid) {
              temp = [...item.list, ...list];
              item.list = temp;
            }
          });
          // console.log(tempCartList)
          window.localStorage.setItem('cartList', JSON.stringify(tempCartList));
          window.location.href = '/shop/cart.html';
        }
      }
    }
  },
};
</script>

<style lang="less">
  .cu-btn {
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 30px;
    padding: 0 25px;
  }
.tips-text {
  font-size: 14px;
  font-weight: 500;
  color: #007F76;
  line-height: 38px;
  padding-top: 2px;
}

.children-module-content {
  padding: 25px !important;
}

.list {
  border: 1px solid #ECECEC;
  padding: 30px;
  display: flex;
  align-items: center;
}

.list .label {
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin-right: 10px;
}

.list .info {
  flex: 1;
}

.list .action {
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: flex-end
}

.list .default {
  font-size: 12px;
  font-weight: 500;
  text-decoration: underline;
  color: #008276;
  line-height: 30px;
  margin-left: 10px;
}

.list .name {
  font-size: 12px;
  color: #999999;
  line-height: 30px;
}

.inner-item {
  line-height: 20px;
}

.company-list {
  border: 1px solid #eee;
  font-size: 12px;
  overflow-y: scroll;
  max-height: 300px;
  position: absolute;
  background-color: #fff;
  z-index: 99999;
  width: 100%;
  font-weight: 600;
}

.company-item {
  line-height: 40px;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
}

.company-list .company-item:hover {
  cursor: pointer;
  background: #F2F8F8;
}

.company-list .company-item:last-child {
  border-bottom: none;
}
  .file-table .ant-table-column-title {
    font-size: 12px;
  }
  .file-list a {
    display: block;
  }
</style>
